import { Configuration } from '@azure/msal-browser';

export type AuthProvider = 'onyx' | 'bhsd';

export const onyxMsalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID ?? '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_AD_TENANT_ID ?? 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const bhsdMsalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_EXTERNAL_CLIENT_ID ?? '',
    authority: `https://onyxfinancialcoordinator.ciamlogin.com/${import.meta.env.VITE_ENTRA_EXTERNAL_TENANT_ID ?? 'onyxfinancialcoordinator.onmicrosoft.com'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    knownAuthorities: ['onyxfinancialcoordinator.ciamlogin.com'],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export function getMsalConfig(provider: AuthProvider): Configuration {
  return provider === 'onyx' ? onyxMsalConfig : bhsdMsalConfig;
}

export function getStoredProvider(): AuthProvider | null {
  const v = sessionStorage.getItem('authProvider');
  return v === 'onyx' || v === 'bhsd' ? v : null;
}

export function setStoredProvider(provider: AuthProvider): void {
  sessionStorage.setItem('authProvider', provider);
}

export function clearStoredProvider(): void {
  sessionStorage.removeItem('authProvider');
}
